/**
 * This component is designed to be used as a child within AlertDialog.
 * It serves as content that will be passed as props to the parent dialog.
 */

import React from 'react';
import { Body1, Body2 } from '../../themes/typography';

function RescheduleConfirmation() {
    return (
        <React.Fragment>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <Body1>Are you sure want to reschedule this event?</Body1>
                <Body2 fontWeight={300}>
                    This will change the event dates and timing for all attendees and also delete
                    all the tickets that are created for this event.
                </Body2>
            </div>
        </React.Fragment>
    );
}

export default RescheduleConfirmation;
